/* eslint-disable react/jsx-no-literals */
import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Message from 'carbon-react/lib/components/message';

import * as styles from './liquidity-overview-card.scss';

type MetricVariant = 'positive' | 'warning' | 'negative' | 'neutral';

export interface LiquidityMetric {
  label: string;
  value: string;
  variant: MetricVariant;
}

export interface LiquidityMessage {
  title: string;
  content: string;
  variant: 'warning' | 'error' | 'info' | 'success';
}

export interface LiquidityOverviewCardProps {
  title: string;
  subtitle?: string;
  metrics: LiquidityMetric[];
  message?: LiquidityMessage;
}

export const LiquidityOverviewCard = ({ title, subtitle, metrics, message }: LiquidityOverviewCardProps) => (
  <div className={styles.cardContainer}>
    <Typography fontSize="21px" fontWeight="500" lineHeight="125%" mb={0}>
      {title}
    </Typography>

    {subtitle && (
      <Typography fontSize="14px" fontWeight="400" lineHeight="150%" mb={0} color="var(--colorsUtilityYin055)">
        {subtitle}
      </Typography>
    )}

    <div className={styles.metricsGrid}>
      {metrics.map(metric => (
        <div key={metric.label} className={styles.metricTile}>
          <Typography fontSize="14px" fontWeight="400" lineHeight="150%" mb={0} color="rgba(0,0,0,0.55)">
            {metric.label}
          </Typography>
          <Typography fontSize="25px" fontWeight="700" lineHeight="125%" mb={0}>
            {metric.value}
          </Typography>
        </div>
      ))}
    </div>

    {message && (
      <Message title={message.title} variant={message.variant} open showCloseIcon={false}>
        {message.content}
      </Message>
    )}
  </div>
);
